import { render, staticRenderFns } from "./KlipperLoadChart.vue?vue&type=template&id=3b02804f&"
import script from "./KlipperLoadChart.vue?vue&type=script&lang=ts&"
export * from "./KlipperLoadChart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports